// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"GY-z","trustedRetailerTooltipWrapper":"HY-z"};